let $baseQuestionPro = 'Are you releasing information that has been announced before?';
const $emailAction = 'Email central comms team for support';
const $releaseAction = 'Go ahead and release';

let $baseQuestionAct = 'Are you dealing with an issue that has been dealt with before?';
const $releaseActionReact = 'Go ahead and share response';
const $emailActionReact = 'Contact central corp comms';


//Yes Path - Proactive
let numbersPerformance = 'Does it include any numbers about performance?';
let strategy = 'Is it to do with strategy company policy?';
let announcement = 'Is the announcement to do with a senior management change';
let priceInfo = 'Does it include information on local price changes or profit / orders';
let otherMarkets = 'Could this impact other markets?';
let results = 'Does it have any numbers that weren’t included in the last set of results?';
let reference = 'Does it reference competition or regulation?';
let share = 'Could it have an impact on our share price?';
let common = 'So it does not mention sales, prices or strategy & is unlikely to impact our share price. STILL APPLY COMMON SENSE. DOES IT FEEL RIGHT?';


//No path - proactive
let former = 'Is the news to do with a former global announcement or central strategic pillars';
let central = 'Has central corp comms had sight of any former announcement you’ve made in this space?';
let sense = 'Sense check with central CC this is the right story and the right timings for the wider group';

//Yes path - Reactive
let hotTopics = 'Have you checked the <a href="https://docs.google.com/spreadsheets/d/1BSPLsVRJ6lX-3Yvbm72ItHFiTiagytSU8YYCpKYqXcY/edit#gid=0" target="_blank">Hot Topics</a> folder for updated lines?';
const centralCC = 'Has your response been approved by relevant parties and have you  sense checked with central CC as needed?';
const senseRe = 'Sense check as needed* with central corp comms';

//No Path - Reactive
const story = 'Is the story likely to generate wider media interest?';
const performance = 'Is it to do with performance /financials / order numbers?';
const serious = 'Is it to do with a serious issue. I.e courier accident / customer harassment?';
const senior = 'Is to do with a senior member of management or allegations against the business?';
const other = 'Have other markets dealt with the same or a similar issue?';
const shareRe = 'Could this impact share price?';
const policy = 'Is it in relation to policy or regulation? I.e CBA agreements?';
const global = 'Is it to do with a global partnership or likely to have global impact?';
const spill = 'Could it spill over into other markets?';
const viral = 'Could it go viral?';

export default {

  en_gb: {
    navbar: {
      logo: 'just-eat-logo',
      country_toggle: [
        {
          logo: 'dk',
          url: ''
        },
        {
          logo: 'gb',
          url: ''
        }
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.co.uk'
    },
    proactive: {
      questions: [
        //step 1 = 0
        {
          question: $baseQuestionPro,
        },
      ],
      yesPath: [
        //Yes Path, Step 2
        {
          question: numbersPerformance,
        },
        {
          question: strategy,
        },
        {
          question: announcement,
        },
        {
          question: priceInfo,
        },
        {
          question: otherMarkets,
        },
        {
          question: results,
        },
        {
          question: reference,
        },
        {
          question: share,
        },
        {
          question: common,
        },
        {
          question: sense,
        }
      ],
      noPath: [
        {
          question: former,
        },
        {
          question: central,
        },
        {
          question: sense,
        }
      ],
      emailAnswer: $emailAction,
      releaseAction: $releaseAction
    },
    reactive: {
      questions: [
        {
          question: $baseQuestionAct,
        }
      ],
      yesPath: [
        {
          question: hotTopics,
        },
        {
          question: centralCC,
        },
        {
          question: senseRe,
        }
      ],
      noPath: [
        {
         question: story, 
        },
        {
          question: performance,
        },
        {
          question: serious,
        },
        {
          question: senior,
        },
        {
          question: other, 
        },
        {
          question: shareRe,
        },
        {
          question: policy,
        },
        {
          question: global,
        },
        {
          question: spill,
        },
        {
          question: viral,
        },
        {
          question: hotTopics,
        },
        {
          question: senseRe
        }
      ],
      emailAnswer: $emailActionReact,
      releaseAction: $releaseActionReact
    }
  }
};
